<script>
export default {
    data: () => ({
        node: null,
    }),
    props: {
        text: String,
        showInfoSign: Boolean,
        valign: {
            type: String,
            default: 'top',
        },
        halign: {
            type: String,
            default: 'center',
        },
    },
    mounted() {
        this.node = document.createElement('div');
        this.node.innerHTML = this.text;
        this.node.className = 'HintPopupAbs';
        this.updatePopupPosition();
        this.node.style.transform += ' scale(0)';
        document.body.appendChild(this.node);
    },
    destroyed() {
        document.body.removeChild(this.node);
    },
    methods: {
        showPopup() {
            const root = this.$refs.root;
            if (root && this.node) {
                this.updatePopupPosition();
            }
        },
        hidePopup() {
            if (this.node) {
                this.node.style.transform += ' scale(0)';
            }
        },
        updatePopupPosition() {
            const root = this.$refs.root;
            if (root && this.node) {
                let transX = 0;
                let transY = 0;
                let originX = 0;
                let originY = 0;
                const bbox = root.getBoundingClientRect();
                switch (this.valign) {
                    case 'top':
                        this.node.style.top = 'auto';
                        this.node.style.bottom = `calc(100vh - ${bbox.top}px)`;
                        originY = '100%';
                        break;
                    case 'center':
                        this.node.style.top = `${bbox.top + (bbox.height / 2)}px`;
                        this.node.style.bottom = 'auto';
                        transY = '-50%';
                        originY = '50%';
                        break;
                    case 'bottom':
                        this.node.style.top = `${bbox.top + bbox.height}px`;
                        this.node.style.bottom = 'auto';
                        originY = '0%';
                        break;
                }
                switch (this.halign) {
                    case 'left':
                        this.node.style.left = 'auto';
                        this.node.style.right = `calc(100vw - ${bbox.left}px)`;
                        originX = '100%';
                        break;
                    case 'center':
                        this.node.style.left = `${bbox.left + (bbox.width / 2)}px`;
                        this.node.style.right = 'auto';
                        transX = '-50%';
                        originX = '50%';
                        break;
                    case 'right':
                        this.node.style.left = `${bbox.left + bbox.width}px`;
                        this.node.style.right = 'auto';
                        originX = '0%';
                        break;
                }
                this.node.style.transformOrigin = `${originX} ${originY}`;
                this.node.style.transform = `translate(${transX}, ${transY})`;
            }
        },
    },
    watch: {
        text(nextVal) {
            if (this.node) {
                this.node.innerHTML = nextVal;
            }
        },
    },
};
</script>

<template>
    <div ref="root" class="HintWrapper" @mouseenter="showPopup()" @mouseleave="hidePopup()">
        <span class="HintWrapperInfo" v-if="showInfoSign">i</span>
        <slot v-else></slot>
    </div>
</template>

<style lang="stylus">
@import '../../stylus/vars.styl'

.HintPopupAbs
    position fixed
    padding 20px
    background #fff
    border 2px solid $cBorder
    color $cPrimary
    font-size 12px
    font-weight 400
    transition .3s all
    z-index 9999

.HintWrapper
    position relative
    .HintWrapperInfo
        display inline-flex
        justify-content center
        align-items center
        width 25px
        height 25px
        font-size 18px
        border-radius 50%
        font-weight 700
        border 2px solid $cBorder
        color $cBorder
        cursor default
        margin: 10px;
</style>


